const Text = ({ textTitle, textContent }) => {
  return (
    <div className="flex flex-col">
      <p className="text-2xl font-bold mb-4">{textTitle}</p>
      <p className="text-sm font-thin">{textContent}</p>
    </div>
  )
}
export default Text
